// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface SaasInstanceBillingPayload
 */
export interface SaasInstanceBillingPayload {
    /**
     * 
     * @type {string}
     * @memberof SaasInstanceBillingPayload
     */
    companyName: string;
    /**
     * (for billing)
     * @type {string}
     * @memberof SaasInstanceBillingPayload
     */
    address: string;
    /**
     * (for billing)
     * @type {string}
     * @memberof SaasInstanceBillingPayload
     */
    city: string;
    /**
     * (for billing)
     * @type {string}
     * @memberof SaasInstanceBillingPayload
     */
    state: string;
    /**
     * (for billing)
     * @type {string}
     * @memberof SaasInstanceBillingPayload
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof SaasInstanceBillingPayload
     */
    billingEmail: string;
    /**
     * 
     * @type {string}
     * @memberof SaasInstanceBillingPayload
     */
    postalCode?: string;
}

export function SaasInstanceBillingPayloadFromJSON(json: any): SaasInstanceBillingPayload {
    return {
        'companyName': json['companyName'],
        'address': json['address'],
        'city': json['city'],
        'state': json['state'],
        'country': json['country'],
        'billingEmail': json['billingEmail'],
        'postalCode': !exists(json, 'postal_code') ? undefined : json['postal_code'],
    };
}

export function SaasInstanceBillingPayloadToJSON(value?: SaasInstanceBillingPayload): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'companyName': value.companyName,
        'address': value.address,
        'city': value.city,
        'state': value.state,
        'country': value.country,
        'billingEmail': value.billingEmail,
        'postal_code': value.postalCode,
    };
}


